import React from "react";
import {
  Button,
  Typography,
  Box,
  Alert,
  Card,
  CardContent,
  Divider,
  Grid,
  Chip,
  Fade,
  Stack,
  alpha,
  useTheme,
} from "@mui/material";
import {
  CheckCircle,
  CreditCard,
  AccountBalance,
  ArrowBack,
} from "@mui/icons-material";

export default function ReceiptStep({
  bankInfo,
  socialChannels,
  handleReceiptSubmit,
}) {
  const theme = useTheme();
  return (
    <Fade in timeout={400}>
      <Stack spacing={3}>
        <Box sx={{ textAlign: "center" }}>
          <CreditCard sx={{ fontSize: 64, color: "secondary.main", mb: 2 }} />
          <Typography variant="h5" gutterBottom fontWeight="bold">
            اطلاعات پرداخت
          </Typography>
          <Typography variant="body1" color="text.secondary">
            برای تکمیل همکاری، مبلغ را به کارت زیر واریز کن
          </Typography>
        </Box>

        <Card
          sx={{
            background: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0.3)}, ${alpha(theme.palette.secondary.dark, 0.1)})`,
            border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Stack spacing={2.5}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="subtitle2" color="text.secondary">
                  مبلغ قابل پرداخت
                </Typography>
                <Chip
                  label={`${bankInfo.amount} تومان`}
                  color="primary"
                  sx={{
                    fontWeight: "bold",
                    fontSize: ".9rem",
                    py: 2,
                    px: "8px",
                  }}
                />
              </Box>

              <Divider
                sx={{
                  borderColor: alpha(theme.palette.common.white, 0.1),
                }}
              />

              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <AccountBalance
                  sx={{ color: "secondary.main", fontSize: 32 }}
                />
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    شماره کارت
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ fontFamily: "monospace", letterSpacing: 2 }}
                  >
                    {bankInfo.cardNumber}
                  </Typography>
                </Box>
              </Box>

              <Box>
                <Typography variant="caption" color="text.secondary">
                  به نام
                </Typography>
                <Typography variant="body1" fontWeight="medium">
                  {bankInfo.cardHolder}
                </Typography>
              </Box>

              <Box>
                <Typography variant="caption" color="text.secondary">
                  بانک
                </Typography>
                <Typography variant="body1">{bankInfo.bankName}</Typography>
              </Box>

              <Alert
                severity="info"
                sx={{
                  backgroundColor: alpha(theme.palette.info.main, 0.1),
                  borderRadius: 2,
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <Typography variant="body2">
                  پس از واریز، حتماً رسید رو از طریق شبکه‌های اجتماعی زیر برامون
                  بفرست
                </Typography>
              </Alert>
            </Stack>
          </CardContent>
        </Card>

        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          ارسال رسید واریز
        </Typography>
        <Grid container spacing={2}>
          {socialChannels.map((social) => (
            <Grid size={{ xs: 12, sm: 4 }} key={social.name}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => window.open(social.link, "_blank")}
                sx={{
                  py: 2,
                  borderColor: social.color,
                  color: social.color,
                  backgroundColor: alpha(social.color, 0.05),
                  "&:hover": {
                    borderColor: social.hoverColor,
                    backgroundColor: alpha(social.color, 0.15),
                    transform: "translateY(-1px)",
                  },
                  transition: "all 0.2s ease",
                }}
              >
                <Stack direction="row" spacing={1} alignItems="center">
                  {social.icon}
                  <Typography fontWeight={500}>{social.name}</Typography>
                </Stack>
              </Button>
            </Grid>
          ))}
        </Grid>

        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={handleReceiptSubmit}
          sx={{
            py: 1.5,
            fontSize: ".9rem",
          }}
        >
          <CheckCircle sx={{ ml: 1, fontSize: "1.3rem" }} />
          رسید رو ارسال کردم
        </Button>

        <Button
          variant="text"
          onClick={() => setActiveStep(0)}
          startIcon={<ArrowBack sx={{ rotate: "180deg", ml: "8px" }} />}
        >
          بازگشت به مرحله قبل
        </Button>
      </Stack>
    </Fade>
  );
}
